module.exports = __webpack_public_path__ + "static/media/icon192.46129f4b.png";